"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderDumpling = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _checkForRenderAnchorTag = require("../../utils/methods/checkForRenderAnchorTag");
var _Image = _interopRequireDefault(require("../Image/Image"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const renderDumpling = _ref => {
  let {
    header,
    icon,
    size,
    link,
    image,
    roundedImage,
    color = "#242D2F",
    Link,
    GatsbyImage
  } = _ref;
  let roundedResult = true;
  if (roundedImage === false) {
    roundedResult = false;
  }
  if (!color) {
    color = "#242D2F";
  }
  return /*#__PURE__*/_react.default.createElement("article", {
    className: `ter-dumpling ter-dumpling--${size}`
  }, icon && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-dumpling__icon-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: icon?.type,
    size: icon?.size,
    color: color ? color : "#242D2F"
  })), (image?.url || image?.src) && (image?.altText || image?.alt) && /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: image?.src || image?.url,
    alt: image?.alt || image?.altText,
    image: image?.image,
    GatsbyImage: GatsbyImage,
    className: `ter-dumpling__image ${roundedResult ? "ter-dumpling__image--rounded" : ""}`
  }), size === "small" && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-dumpling__small-dash",
    style: {
      borderTop: `solid 1px ${color}` || "solid 1px ##242D2F"
    }
  }), !link && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-dumpling__text",
    style: {
      color: color || "#242D2F"
    }
  }, header), link && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    className: `ter-dumpling__link ter-dumpling__link--${size}`,
    style: {
      color: color || "#242D2F"
    },
    to: link?.url,
    Link: Link && Link
  }, header), /*#__PURE__*/_react.default.createElement("div", null));
};
exports.renderDumpling = renderDumpling;